@let ci = content();
@if (ci) {
  <div class="track-banner">
    <div class="metadata-wrapper">
      <div class="title-and-performer">
        <div class="track-name">{{ ci.name }}</div>
        @if (ci.performerName) {
          <div class="divider">-by-</div>
          <div class="performer-name">{{ ci.performerName }}</div>
        }
      </div>
      @if (ci.releaseName && ci.releaseName !== ci.name) {
        <div class="divider">-from-</div>
        <div class="release-name">{{ ci.releaseName }}</div>
      }
    </div>
  </div>
}
